import { render } from "./page-editor.vue?vue&type=template&id=735a262c&scoped=true"
import script from "./page-editor.vue?vue&type=script&lang=js"
export * from "./page-editor.vue?vue&type=script&lang=js"

import "./page-editor.vue?vue&type=style&index=0&id=735a262c&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735a262c"]])

export default __exports__